module.exports = __webpack_public_path__ + "assets/img/img-detail-02.b89d43e9.jpg";